<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3216_144)">
<g opacity="0.2">
<path d="M1 5C1 4.44772 1.44772 4 2 4H18C18.5523 4 19 4.44772 19 5V6C19 6.55228 18.5523 7 18 7H2C1.44772 7 1 6.55228 1 6V5Z" fill="currentColor"/>
<path d="M1 17C1 16.4477 1.44772 16 2 16H18C18.5523 16 19 16.4477 19 17V18C19 18.5523 18.5523 19 18 19H2C1.44772 19 1 18.5523 1 18V17Z" fill="currentColor"/>
<path d="M1 11C1 10.4477 1.44772 10 2 10H18C18.5523 10 19 10.4477 19 11V12C19 12.5523 18.5523 13 18 13H2C1.44772 13 1 12.5523 1 12V11Z" fill="currentColor"/>
</g>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 5C0 3.89543 0.895431 3 2 3H18C19.1046 3 20 3.89543 20 5V6C20 7.10457 19.1046 8 18 8H13V9H18C19.1046 9 20 9.89543 20 11V12C20 13.1046 19.1046 14 18 14H13V15H18C19.1046 15 20 15.8954 20 17V18C20 19.1046 19.1046 20 18 20H2C0.895432 20 0 19.1046 0 18V17C0 15.8954 0.895431 15 2 15H7V14H2C0.895432 14 0 13.1046 0 12V11C0 9.89543 0.895431 9 2 9H7V8H2C0.895432 8 0 7.10457 0 6V5ZM18 5H2V6H18V5ZM18 17H2V18H18V17ZM18 11H2V12H18V11Z" fill="currentColor"/>
<path d="M11 2L1 2C1 0.89543 1.89543 -9.65645e-08 3 0L9 5.24537e-07C10.1046 6.21101e-07 11 0.895431 11 2Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3216_144">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
